import React from 'react';
import PropTypes from "prop-types";
const Breadcrumb = ({crumbs, type, font}) => {

  function isLast(index) {
    return index === crumbs.length - 1;
  }
  return (
    <nav>
      <ol className="breadcrumb library-breadcrumbs">
        {
          crumbs.map((crumb, ci) => {
            const disabled = isLast(ci) ? 'disabled' : '';
            
            return (
              <li
                key={ crumb.id }
                className="breadcrumb-item align-items-center"
                type={type} font={`${ font }px`}>
                <a href={crumb.href} className={ `btn btn-link ${ disabled }` } >
                  { crumb.label }
                </a>
              </li>
              
            );
          })
        }
      </ol>
    </nav>
  );
}
Breadcrumb.prototype = {
  type: PropTypes.string,
  font: PropTypes.number,
};

Breadcrumb.defaultProps = {
  type: "text",
  font: 16
};
export default Breadcrumb;